import React from 'react';
import styled from 'styled-components';

const ErrorStyle = styled.div`
  margin: 3rem 0;
  padding: 0 1rem;
  text-align: center;
`;

export const Error = ({ children }) => {
  return (
    <ErrorStyle>
      <h3>Something went wrong...</h3>
      <p>{children}</p>
    </ErrorStyle>
  );
};
